/**
 * Generic drawer using the theme right drawer (same shell as the cart drawer).
 *
 *   document.dispatchEvent(new Event('theme:open:custom-drawer'));
 *   document.dispatchEvent(new Event('theme:close:custom-drawer'));
 *
 * When this drawer is open it uses the same slot as the cart; the active content
 * is whichever modal was opened last (theme modals are one-at-a-time per slot).
 */

document.addEventListener('alpine:init', () => {
  Alpine.store('modals').register('customDrawer', 'rightDrawer');

  document.addEventListener('wk:open:wishlist-drawer', () => {
    Alpine.store('modals').open('customDrawer');
  });

  document.addEventListener('wk:close:wishlist-drawer', () => {
    Alpine.store('modals').close('customDrawer');
  });
});
